module.exports = __webpack_public_path__ + "fonts/ProximaNova-Regular.410504d4.otf";